module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h3', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Detalhes da alteração")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "m-b-lg"
  }, [_vm._v("\n            Alteração realizada por: " + _vm._s(_vm.logSelecionado.username) + "\n            "), _c('link-historico-alteracoes', {
    attrs: {
      "to": {
        name: 'usuarios.visualizar',
        params: {
          id: _vm.logSelecionado.usuario.id
        }
      },
      "label": "Visualizar usuário",
      "icon": "fa-user-circle-o"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-t-sm"
  }, [_vm._v("Data: " + _vm._s(_vm._f("formatDate")(_vm.logSelecionado.data.date, 'DD/MM/YYYY HH:mm:ss')))]), _vm._v(" "), _c('div', {
    staticClass: "m-t-sm"
  }, [_vm._v("Descrição da alteração: " + _vm._s(_vm.logSelecionado.descricao))]), _vm._v(" "), _c('div', {
    staticClass: "m-t-sm"
  }, [_vm._v("Entidade alterada: " + _vm._s(_vm.logSelecionado.entidade))]), _vm._v(" "), (_vm.possuiMotivo) ? _c('div', {
    staticClass: "m-t-sm"
  }, [_c('strong', [_vm._v("Motivo:")]), _vm._v(" " + _vm._s(_vm.logSelecionado.extra.motivo || '-') + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.logSelecionado.extra) ? _c('div', {
    staticClass: "m-t-sm"
  }, [(_vm.logSelecionado.extra.oldArrematanteId) ? _c('link-historico-alteracoes', {
    attrs: {
      "to": {
        name: 'arrematante.visualizar',
        params: {
          id: _vm.logSelecionado.extra.oldArrematanteId
        }
      },
      "label": "Visualizar arrematante anterior",
      "icon": "fa-user"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.logSelecionado.extra.newArrematanteId) ? _c('link-historico-alteracoes', {
    attrs: {
      "to": {
        name: 'arrematante.visualizar',
        params: {
          id: _vm.logSelecionado.extra.newArrematanteId
        }
      },
      "label": "Visualizar novo arrematante",
      "icon": "fa-user"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.logSelecionado.extra.leilaoId) ? _c('link-historico-alteracoes', {
    attrs: {
      "to": {
        name: 'lotes.visualizar',
        params: {
          leilao: _vm.logSelecionado.extra.leilaoId,
          id: _vm.logSelecionado.entidadeId
        }
      },
      "label": "Visualizar lote",
      "icon": "fa-car"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "m-t-sm"
  }, [((_vm.logSelecionado.entidade === 'grv' || _vm.logSelecionado.entidade === 'ggv') && _vm.logSelecionado.operacao !== 'DELETE') ? _c('link-historico-alteracoes', {
    attrs: {
      "to": {
        name: 'grv.visualizar.patio',
        params: {
          id: _vm.logSelecionado.entidadeId
        }
      },
      "label": "Visualizar GRV",
      "icon": "fa-file-text-o"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.logSelecionado.entidade === 'usuario' && _vm.logSelecionado.operacao !== 'DELETE') ? _c('link-historico-alteracoes', {
    attrs: {
      "to": {
        name: 'usuarios.visualizar',
        params: {
          id: _vm.logSelecionado.entidadeId
        }
      },
      "label": "Visualizar usuário alterado",
      "icon": "fa-user-circle-o"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.logSelecionado.entidade === 'arrematante') ? _c('link-historico-alteracoes', {
    attrs: {
      "to": {
        name: 'arrematante.visualizar',
        params: {
          id: _vm.logSelecionado.entidadeId
        }
      },
      "label": "Visualizar arrematante",
      "icon": "fa-user"
    }
  }) : _vm._e()], 1)], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e903e45c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/historico-alteracoes/components/DetalhesLogAlteracao.vue
// module id = 2081
// module chunks = 18